module.exports = __webpack_public_path__ + "img/Primeo_120X35.dd8fe179.png";